// check for US IP address before displaying email share icon
(function () {
    const geocodeLoadedDeferred = $.Deferred();
    const documentReadyDeferred = $.Deferred();

    if (window.refreshGeoLocation) {
        geocodeLoadedDeferred.resolve();
    } else {
        $(document).on('geocodeLoaded', function (e) {
            geocodeLoadedDeferred.resolve();
        });
    }

    $(document).ready(function (e) {
        documentReadyDeferred.resolve();
    });

    $.when(geocodeLoadedDeferred, documentReadyDeferred).done(function () {
        if ($('.js-share-by-email').length > 0 || $('.js-share-email').length > 0) {
            const geoLocation = readCookie('geoLocation');
            if (geoLocation) {
                hideOrShowShareByEmail(JSON.parse(geoLocation));
            } else {
                refreshGeoLocation();
            }
        }
    });

    $(document).on('geoCallComplete', function (event, geoLocation) {
        hideOrShowShareByEmail(geoLocation);
    });

    // .js-share-email appears in sharebar.tag, which is included on several pages
    /**
     * This is supposed to hide the email button for users outside the US,
     * but it doesn't work very well. The style from the hide class can be overriden
     * by other classes. That's definitely the case on the project page.
     *
     * Should this be changed to use directly hide the element?
     */
    function hideOrShowShareByEmail(geoLocation) {
        if (geoLocation && geoLocation.country && geoLocation.country !== 'US') {
            $('.js-share-by-email').addClass('hide');
            $('.js-share-email').addClass('hide');
        } else if (geoLocation && geoLocation.country && geoLocation.country === 'US') {
            $('.js-share-by-email').removeClass('hide');
            $('.js-share-email').removeClass('hide');
        } else if (!geoLocation) { // ad blockers sometimes block maxmind; if geoLocation cookie is missing, show the email link anyway
            $('.js-share-by-email').removeClass('hide');
            $('.js-share-email').removeClass('hide');
        }
    }
})();
